<script lang="ts">
import SuperAdminLayout from "@/layouts/SuperAdminLayout.vue"

export default { layout: SuperAdminLayout }
</script>

<script setup lang="ts">
import { Head, useForm } from "@inertiajs/vue3"

import FlashAlerts from "@/components/FlashAlerts.vue"
import { superAdminUsersPath } from "@/routes"

const form = useForm({
  first_name: "",
  last_name: "",
  email_address: "",
  password: "",
  password_confirmation: "",
  super_admin: false,
})

function submit() {
  form.post(superAdminUsersPath())
}
</script>

<template>
  <Head title="New User — Admin" />

  <div class="flex flex-col gap-6">
    <FlashAlerts />

    <form class="flex flex-col gap-4" @submit.prevent="submit">
      <UFormField label="First name" :error="form.errors.first_name">
        <UInput v-model="form.first_name" required autofocus maxlength="50" />
      </UFormField>

      <UFormField label="Last name" :error="form.errors.last_name">
        <UInput v-model="form.last_name" required maxlength="100" />
      </UFormField>

      <UFormField label="Email" :error="form.errors.email_address">
        <UInput v-model="form.email_address" type="email" required autocomplete="off" />
      </UFormField>

      <UFormField label="Password" :error="form.errors.password">
        <UInput
          v-model="form.password"
          type="password"
          required
          autocomplete="new-password"
          maxlength="72"
        />
      </UFormField>

      <UFormField label="Password confirmation" :error="form.errors.password_confirmation">
        <UInput
          v-model="form.password_confirmation"
          type="password"
          required
          autocomplete="new-password"
          maxlength="72"
        />
      </UFormField>

      <USwitch v-model="form.super_admin" label="Super Admin" />

      <div class="flex gap-4">
        <UButton label="Cancel" color="neutral" variant="outline" :to="superAdminUsersPath()" />
        <UButton type="submit" label="Create User" :loading="form.processing" />
      </div>
    </form>
  </div>
</template>
